export default {
  id: 'CreateSchoolModal',
  code: 'CN',
  text: {
    'School Email': '学校邮箱',
    'School Phone No.': '学校电话号码',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/CreateSchool/locale.js